import { render, staticRenderFns } from "./clue_select.vue?vue&type=template&id=a3804232&scoped=true&"
import script from "./clue_select.vue?vue&type=script&lang=ts&"
export * from "./clue_select.vue?vue&type=script&lang=ts&"
import style0 from "./clue_select.vue?vue&type=style&index=0&id=a3804232&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3804232",
  null
  
)

export default component.exports